import React, { useMemo, useState } from "react";
import { Search } from "lucide-react";

const isAddr = (s) => /^0x[0-9a-fA-F]{40}$/.test(s.trim());

export function TokenPicker({ tokens, value, onChange }) {
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return tokens.slice(0, 40);
    return tokens.filter((t) => t.symbol.toLowerCase().includes(s) || t.name.toLowerCase().includes(s) || t.address === s).slice(0, 40);
  }, [q, tokens]);

  const pickCustom = () => onChange({ address: q.trim().toLowerCase(), symbol: "Custom", name: "Custom token" });

  return (
    <div data-testid="burn-token-picker">
      <div className="flex items-center gap-2 bg-[#12131C] border border-[#2A2E45] rounded-xl px-3 py-2">
        <Search size={14} className="text-slate-500" />
        <input data-testid="burn-token-search" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Search a coin or paste its Cronos address" className="bg-transparent outline-none text-sm flex-1" />
      </div>
      {isAddr(q) && !list.length && (
        <button data-testid="burn-token-custom" onClick={pickCustom} className="mt-2 chip hover:brightness-125">Use {q.slice(0, 8)}…</button>
      )}
      <div className="mt-2 max-h-44 overflow-y-auto flex flex-wrap gap-2">
        {list.map((t) => (
          <button key={t.address} onClick={() => onChange(t)} data-testid={`burn-token-${t.symbol.toLowerCase()}`}
            className={`chip flex items-center gap-1 transition-[filter,border-color] hover:brightness-125 ${value?.address === t.address ? "border-orange-500 text-orange-300" : ""}`}>
            {t.logo && <img src={t.logo} alt="" className="w-4 h-4 rounded-full" />}{t.symbol}
          </button>
        ))}
      </div>
    </div>
  );
}
